export default __webpack_public_path__ + "static/media/play.a5d3b6db.svg";